import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router' 
import store from './store'
import axios from 'axios'
import VueWait from 'vue-wait'
import VueSVGIcons from 'vue-svgicon'
import VueMeta from 'vue-meta';

Vue.use(VueMeta);

import '@mdi/font/css/materialdesignicons.css'

Vue.use(VueWait)
Vue.use(VueSVGIcons)
Vue.config.productionTip = false
const moment = require('moment')
require('moment/locale/hr')
 
Vue.use(require('vue-moment'), {
    moment
})

// axios configuration
axios.defaults.withCredentials = true;
// axios.create({ withCredentials: true })
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

axios.defaults.baseURL = "https://api.sum.ba"
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
     window.location.href = `https://api.sum.ba/sso/login?redirect_to=${location.href}`
  }
  if (error.response.status === 403) {
    window.location.href = `https://api.sum.ba/sso/login?redirect_to=${location.href}`
 }
    // return Promise.reject(error)
    return error.response
})
// Components
import NavBar from './components/NavBar.vue'
Vue.component('nav-bar', NavBar)
import Cover from './components/Cover'
Vue.component('cover', Cover)
import AppFooter from './components/AppFooter'
Vue.component('app-footer', AppFooter)
import AppNavigation from './components/AppNavigation.vue'
Vue.component('app-navigation', AppNavigation)
import Loader from './components/Loader.vue'
Vue.component('loader', Loader)

import FormOne from './views/components/FormOne.vue'
Vue.component('form-one', FormOne)
import FormTwo from './views/components/FormTwo.vue'
Vue.component('form-two', FormTwo)
import FormThree from './views/components/FormThree.vue'
Vue.component('form-three', FormThree)
import FormFour from './views/components/FormFour.vue'
Vue.component('form-four', FormFour)
import FormFive from './views/components/FormFive.vue'
Vue.component('form-five', FormFive)
import FormSix from './views/components/FormSix.vue'
Vue.component('form-six', FormSix)
import Uposlenici from './views/AkademskoOsoblje.vue'
Vue.component('uposlenici', Uposlenici)
import Studenti from './views/Studenti.vue'
Vue.component('studenti', Studenti)
import StraniAutori from './views/ForeignAuthors.vue'
Vue.component('strani-autori', StraniAutori)
import Details from './views/components/Details.vue'
Vue.component('detalji-rada', Details)
import IzdanjeDetails from './views/components/IzdanjeDetails.vue'
Vue.component('detalji-izdanja', IzdanjeDetails)
import UposlenikDeatils from './views/components/UposlenikDetails.vue'
Vue.component('detalji-uposlenik', UposlenikDeatils)
import StudentDetails from './views/components/StudentDetails.vue'
Vue.component('detalji-student', StudentDetails)
import StraniAutorDetails from './views/components/StraniAutorDetails.vue'
Vue.component('detalji-strani-autor', StraniAutorDetails)
import HintsPanel from './components/HintsPanel.vue'
Vue.component('hint', HintsPanel)

Vue.config.warnHandler = function (msg, vm, trace) {
  if (msg !== 'Invalid prop: custom validator check failed for prop "selectionType".') {
    const hasConsole = typeof console !== 'undefined';
    if (hasConsole && !Vue.config.silent) {
      console.error(`[Vue warn]: ${msg}${trace}`);
    }
  }
}

new Vue({
  wait: new VueWait({
    useVuex: true
  }),
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
